var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import ThreeSixtyImageView from './ThreeSixtyImageView';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1 } from './service/constants';
var ThreeSixtyImageViewMap = function (_a) {
    var propVariant = _a.variant, gtmVehicleData = _a.gtmVehicleData, props = __rest(_a, ["variant", "gtmVehicleData"]);
    var appName = useAppName();
    var variant;
    switch (appName) {
        // ### VARIANT2 — can be pass through propVariant and used in BAP pages
        default:
            variant = variant1;
    }
    var appNameConfig = useMemo(function () { return ({ variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant }); }, [propVariant, variant]);
    return React.createElement(ThreeSixtyImageView, __assign({ appNameConfig: appNameConfig, gtmVehicleData: gtmVehicleData }, props));
};
export default ThreeSixtyImageViewMap;
